export function abortSignalTimeout(ms) {
    const controller = new AbortController();
    setTimeout(() => controller.abort(new DOMException('TimeoutError')), ms);
    return controller.signal;
}
/*#__PURE__*/
export function isSupported() {
    return 'abort' in AbortSignal && typeof AbortSignal.timeout === 'function';
}
/*#__PURE__*/
export function isPolyfilled() {
    return AbortSignal.timeout === abortSignalTimeout;
}
export function apply() {
    if (!isSupported()) {
        AbortSignal.timeout = abortSignalTimeout;
    }
}
//# sourceMappingURL=abortsignal-timeout.js.map